import * as React from 'react'
import { Box, Typography } from 'cs-kevlar-react'
import { UserLicenseEvents } from '../../../../api'

interface UserMigrationPlanProps {
  userLicenseEvents: UserLicenseEvents
}

export const UserMigrationPlan: React.FunctionComponent<UserMigrationPlanProps> = ({
  userLicenseEvents,
}) => {
  const hasUserEvents = userLicenseEvents.hasEvents
  const hasUserMovedEvents = userLicenseEvents.movedEvents?.length > 0 ?? false
  const hasUserRemovedEvents =
    userLicenseEvents.removedEvents?.length > 0 ?? false

  if (!hasUserEvents) return null

  return (
    <Box>
      <Typography>User Changes</Typography>
      <ul>
        {hasUserMovedEvents &&
          userLicenseEvents.movedEvents.map((moveEvent, idx) => (
            <li key={`UserMoveEvents::${idx}`}>
              <Typography>
                {moveEvent.userLicense.name} moved to{' '}
                {moveEvent.targetAgencyLicense.name}
              </Typography>
            </li>
          ))}
        {hasUserRemovedEvents &&
          userLicenseEvents.removedEvents.map((removeEvent, idx) => (
            <li key={`UserRemoveEvents::${idx}`}>
              <Typography>{removeEvent.userLicense.name} removed</Typography>
            </li>
          ))}
      </ul>
    </Box>
  )
}
